import { CALL_STATUS } from '../constants/list';

export function updateCallStatus(callStatus) {

  return {
    type: CALL_STATUS,
    payload: callStatus
  }

}